import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { ModuleNames } from '../../constants/componentNames.constants'
import options from './searchRichTextRenderer'

import { LocaleCodes } from '../../constants/localization.constants'
import { isResourceCategory } from '../../utils/functions.utils'
import { mapLocale } from '../../utils/pageCreation.utils'

//@ts-ignore
import he from 'he'
// ----------------- MAPPING DATA ----------------- //
export const setLocalizedMicrocopyResourcesMap = (resourceList: any) => {
  const localizedMapping: any = {}
  resourceList.forEach((resource: any) => {
    let key = resource?.node?.key
    if (key === 'Resources') localizedMapping[LocaleCodes.ENGLISH.code] = resource?.node
    else if (key === 'Resources-KO') localizedMapping[LocaleCodes.KOREAN.code] = resource?.node
    else if (key === 'Resources-JA') localizedMapping[LocaleCodes.JAPANESE.code] = resource?.node
    else if (key === 'Resources-ES') localizedMapping[LocaleCodes.SPANISH.code] = resource?.node
    else if (key === 'Resources-PT') localizedMapping[LocaleCodes.PORTUGUESE.code] = resource?.node
    else if (key === 'Resources-FR') localizedMapping[LocaleCodes.FRENCH.code] = resource?.node
    else if (key === 'Resources-DE') localizedMapping[LocaleCodes.GERMAN.code] = resource?.node
    else if (key === 'Resources-CN') localizedMapping[LocaleCodes.CHINESE.code] = resource?.node
  })
  return localizedMapping
}

// Used to merge localized pages-{contentType} and component-externalResource
export const mergeLocalizedResources = (resourceListA: any, resourceListB: any) => {
  const localizedResourcesMap: any = {
    [LocaleCodes.ENGLISH.code]: [],
    [LocaleCodes.FRENCH.code]: [],
    [LocaleCodes.GERMAN.code]: [],
    [LocaleCodes.JAPANESE.code]: [],
    [LocaleCodes.KOREAN.code]: [],
    [LocaleCodes.PORTUGUESE.code]: [],
    [LocaleCodes.SPANISH.code]: [],
    [LocaleCodes.CHINESE.code]: [],
  }

  localizedResourcesMap[LocaleCodes.ENGLISH.code] = [
    ...resourceListA[LocaleCodes.ENGLISH.code],
    ...resourceListB[LocaleCodes.ENGLISH.code],
  ]

  localizedResourcesMap[LocaleCodes.FRENCH.code] = [
    ...resourceListA[LocaleCodes.FRENCH.code],
    ...resourceListB[LocaleCodes.FRENCH.code],
  ]

  localizedResourcesMap[LocaleCodes.GERMAN.code] = [
    ...resourceListA[LocaleCodes.GERMAN.code],
    ...resourceListB[LocaleCodes.GERMAN.code],
  ]

  localizedResourcesMap[LocaleCodes.JAPANESE.code] = [
    ...resourceListA[LocaleCodes.JAPANESE.code],
    ...resourceListB[LocaleCodes.JAPANESE.code],
  ]

  localizedResourcesMap[LocaleCodes.KOREAN.code] = [
    ...resourceListA[LocaleCodes.KOREAN.code],
    ...resourceListB[LocaleCodes.KOREAN.code],
  ]

  localizedResourcesMap[LocaleCodes.PORTUGUESE.code] = [
    ...resourceListA[LocaleCodes.PORTUGUESE.code],
    ...resourceListB[LocaleCodes.PORTUGUESE.code],
  ]

  localizedResourcesMap[LocaleCodes.SPANISH.code] = [
    ...resourceListA[LocaleCodes.SPANISH.code],
    ...resourceListB[LocaleCodes.SPANISH.code],
  ]

  localizedResourcesMap[LocaleCodes.CHINESE.code] = [
    ...resourceListA[LocaleCodes.CHINESE.code],
    ...resourceListB[LocaleCodes.CHINESE.code],
  ]

  return localizedResourcesMap
}
export const extractFilters = (filters: any) => {
  const filterGroups: any = {}

  filters.forEach((filter: any) => {
    if (filter.__typename) {
      let filterName =
        filter.__typename === ModuleNames.TOPIC_CUSTOMER_DETAILS
          ? filter.customerName
          : filter.title
      if (filter.__typename === ModuleNames.TOPIC_CUSTOMER_DETAILS) {
        if (filter.whiteLogo) {
          filterGroups['CustomerLogo'] = filter.whiteLogo
        }
      }

      if (filter.__typename in filterGroups) filterGroups[filter.__typename].push(filterName)
      else filterGroups[filter.__typename] = [filterName]
    }
  })

  return filterGroups
}

export const extractTeaserData = (data: any, type: any, isPreview: any) => {
  let title = ''
  let teaserImage = ''
  let teaserAlt = ''
  let body = ''

  if (type === ModuleNames.PAGE_RESOURCE_DEMO) {
    title = data.hero?.headline
    teaserImage = data.spotlight?.video?.image?.file?.url
    teaserAlt = data.spotlight?.video?.image?.altText
    body = data.spotlight?.body?.raw
      ? documentToHtmlString(
          JSON.parse(data.spotlight.body.raw),
          options(data.spotlight.body.references)
        )
      : ''
  } else if (type === ModuleNames.TEASER) {
    title = data.title
    teaserImage = data.image?.image?.file?.url
    teaserAlt = data.image?.altText
  } else {
    title = data.h1Title
    teaserImage = data.mainImage?.image?.file?.url
    teaserAlt = data.mainImage?.altText
  }

  let categoryFieldId = type === ModuleNames.TEASER ? 'category' : 'resourceCategory'

  let categoryNumber = data[categoryFieldId]?.number

  if (!body && isPreview && data?.body?.content) {
    body = documentToHtmlString(data.body, options())
  } else if (!body && data.body?.raw) {
    body = documentToHtmlString(JSON.parse(data.body.raw), options(data.body.references))
  }

  body = body.toLowerCase()

  let teaserBody
  // For ModuleNames.TEASER, use the body field, otherwise use teaserBody or seo description
  if (type === ModuleNames.TEASER && isPreview)
    teaserBody = documentToHtmlString(data.body, options())
  else if (type === ModuleNames.TEASER && data.body?.raw)
    teaserBody = documentToHtmlString(JSON.parse(data.body.raw), options(data.body.references))
  else teaserBody = data.teaserBody || data.seoMetadata?.pageMetaDescription || ''

  const isResourceDemo = isResourceCategory('Video Demo', categoryNumber)
  const isCustomerStory = isResourceCategory('Case Study', categoryNumber)

  let icon, iconAlt
  if (isResourceDemo) {
    icon = data[categoryFieldId]?.colorImage?.image?.file?.url
    iconAlt = data[categoryFieldId]?.colorImage?.altText
  } else if (isCustomerStory) {
    let customerIcon
    if (type === ModuleNames.PAGE_CUSTOMER_STORY) {
      customerIcon = data?.metaInformation?.filter(
        (meta: any) => meta.__typename === 'CustomerDetail'
      )[0]
    } else if (type === ModuleNames.TEASER) {
      customerIcon = data?.companyLogo
    }

    icon = customerIcon?.image?.file?.url
    iconAlt = customerIcon?.altText
  }

  if (!icon && !isResourceDemo) {
    icon = data[categoryFieldId]?.whiteImage?.image?.file?.url
    iconAlt = data[categoryFieldId]?.whiteImage?.altText
  }

  let teaserData: any = {
    title,
    teaserImage,
    teaserAlt,
    id: data.id,
    teaserBody: he.decode(teaserBody),
    body: he.decode(body),
    slug: data.slug,
    date: data.date,
    categoryNumber,
    category: data[categoryFieldId]?.title,
    icon,
    iconAlt,
    locale: data.node_locale,
    entryLocale: data.entryLocale,
    featured: data.featured || false,
    inEnglish: data.inEnglish,
  }

  // WEBINAR
  if (data.useCase) teaserData['useCase'] = data.useCase

  // EVENT
  if (isResourceCategory('Events', categoryNumber))
    teaserData['eventType'] = data?.metaInformation?.filter(
      (meta: any) => meta.__typename === ModuleNames.TOPIC_EVENT_TYPE
    )[0]?.title

  // SET FILTERS MAP
  let metaInformationFilters =
    (data.metaInformation &&
      Array.isArray(data.metaInformation) &&
      extractFilters(data.metaInformation)) ||
    {}

  let topicsFilter =
    (data.topics && Array.isArray(data.topics) && extractFilters(data.topics)) || {}

  if (Object.keys(metaInformationFilters).length > 0)
    teaserData = { ...teaserData, ...metaInformationFilters }
  if (Object.keys(topicsFilter).length > 0) teaserData = { ...teaserData, ...topicsFilter }

  return teaserData
}

export const localizedMapping = () => ({
  [LocaleCodes.ENGLISH.code]: [],
  [LocaleCodes.FRENCH.code]: [],
  [LocaleCodes.GERMAN.code]: [],
  [LocaleCodes.JAPANESE.code]: [],
  [LocaleCodes.KOREAN.code]: [],
  [LocaleCodes.PORTUGUESE.code]: [],
  [LocaleCodes.SPANISH.code]: [],
  [LocaleCodes.CHINESE.code]: [],
})

export const setLocalizedResourcesMap = (resourceList: any, type: any) => {
  const localizedResourcesMap: any = localizedMapping()

  resourceList.forEach((resource: any) => {
    const localeOfEntry = resource?.node?.entryLocale
    const nodeLocale = resource?.node?.node_locale

    let pageLocale
    const localeInfo = mapLocale(localeOfEntry)
    if (localeInfo?.pageLocale) pageLocale = localeInfo.pageLocale

    if (
      nodeLocale &&
      pageLocale &&
      pageLocale === nodeLocale &&
      nodeLocale in localizedResourcesMap
    ) {
      let teaserData = extractTeaserData(resource.node, type, process.env.IS_PREVIEW)
      localizedResourcesMap[nodeLocale].push(teaserData)
    }
  })

  return localizedResourcesMap
}

// ----------------- SORTING DATA ----------------- //
export const getUpcomingResources = (resourceList: any) => {
  let upcomingResources: any = []
  // We only need to display most RECENT 6 upcoming
  const MAX = 6
  resourceList.forEach((resource: any) => {
    if (
      resource.date &&
      (isResourceCategory('Webinar', resource.categoryNumber) ||
        isResourceCategory('Events', resource.categoryNumber))
    ) {
      let date = new Date(resource.date)
      let now = new Date()

      if (date > now && upcomingResources.length < MAX) {
        upcomingResources.push(resource)
      } else if (upcomingResources.length === MAX) return upcomingResources
    }
  })
  return upcomingResources
}

export const getFeaturedResources = (resourceList: any) => {
  let featuredResources: any = []
  // We only need to display most RECENT 6 featured
  const MAX = 6
  resourceList.forEach((resource: any) => {
    if (resource.featured) {
      if (featuredResources.length < MAX) {
        featuredResources.push(resource)
      } else return featuredResources
    }
  })
  return featuredResources
}

export const sortResourceList = (resourceList: any, isDesc: any) => {
  return resourceList.sort((r1: any, r2: any) => {
    try {
      //@ts-ignore
      if (isDesc) return new Date(r2.date) - new Date(r1.date)
      //@ts-ignore
      else return new Date(r1.date) - new Date(r2.date)
    } catch (e) {
      console.log('Error converting to date: ', e)
      return 0
    }
  })
}

export const getResourceListOrdering = (resourceList: any) => {
  let upcomingResources = getUpcomingResources(resourceList)
  let featuredResources = getFeaturedResources(resourceList)

  let featuredTeaserCards = []
  let featuredIds: any = []

  for (let i = 0; i < upcomingResources.length; i++) {
    if (featuredTeaserCards.length < 6) {
      featuredTeaserCards.push(upcomingResources[i])
      featuredIds.push(upcomingResources[i].slug)
    } else break
  }

  for (let i = 0; i < featuredResources.length; i++) {
    if (featuredResources.length > 6) break
    if (featuredIds.indexOf(featuredResources[i].slug) === -1) {
      featuredTeaserCards.push(featuredResources[i])
      featuredIds.push(featuredResources[i].slug)
    }
  }

  let remainingResources = resourceList.filter((resource: any) => {
    return !featuredIds.includes(resource.slug)
  })

  // sort featured teaser cards in DESC order
  // sort remaining teaser cards in DESC order
  return [
    ...sortResourceList(featuredTeaserCards, true),
    ...sortResourceList(remainingResources, true),
  ]
}

export const existsInFilterLists = (type: any, filter: any, filterLists: any) => {
  for (let i = 0; i < filterLists.length; i++) {
    if (
      filterLists[i] &&
      filterLists[i].items &&
      filterLists[i].items.length &&
      filterLists[i].items.length > 0
    ) {
      const contains = filterLists[i].items.find(
        (item: any) => item.title === filter && item.__typename === type
      )
      if (contains) return true
    }
  }
  return false
}

// Object keys starting with "Contentful" indicates a filter array
export const getTopThreeFilters = (resourceList: any, listingFilters: any) => {
  let filtersCount: any = {}

  resourceList.forEach((resource: any) => {
    for (let key in resource) {
      if (key.startsWith('Contentful')) {
        let filterArray = resource[key]
        for (let i = 0; i < filterArray.length; i++) {
          if (!existsInFilterLists(key, filterArray[i], listingFilters)) continue
          if (filterArray[i] in filtersCount) {
            filtersCount[filterArray[i]] += 1
          } else {
            filtersCount[filterArray[i]] = 1
          }
        }
      }
    }
  })

  const sortDesc = Object.entries(filtersCount).sort(
    //@ts-ignore
    ([, countA], [, countB]) => countB - countA
  )

  const topThreeFilters = sortDesc.slice(0, 3).reduce((acc, [key]) => {
    //@ts-ignore
    acc.push(key)
    return acc
  }, [])

  return topThreeFilters
}
